import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './router';
import './app/globals.css';
import { initPostHog } from './utils/posthog';

/**
 * Main entry point for the Raidu website application
 * Renders the root App component to the DOM
 */
function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

try {
  if (isBrowser()) {
    // Initialize PostHog analytics
    initPostHog();
    
    // Get the root element from the DOM
    const rootElement = document.getElementById('root');
    // Log application initialization
    console.log('[main.tsx] Initializing Raidu website application');
    if (!rootElement) {
      throw new Error('Root element not found in the DOM');
    }
    // Create a React root and render the Router component
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <AppRouter />
      </React.StrictMode>
    );
    // Log successful render
    console.log('[main.tsx] Application successfully rendered');
  } else {
    // SSG/SSR: Do not run DOM code
    console.log('[main.tsx] Skipping DOM render (not in browser)');
  }
} catch (error) {
  // Log any errors that occur during initialization
  console.error('[main.tsx] Failed to initialize application:', error);
}
